import { useEffect, useState } from 'react';
import { useInterval, useTimeout } from 'usehooks-ts';

// Import hooks
import { useCurrentTime } from './useCurrentTime';

export const useUpdateCurrentTime = () => {
	const [isIntervalActive, setIsIntervalActive] = useState(false);

	const setCurrentTime = useCurrentTime((state) => state.setCurrentTime);

	// set timeout to the number of seconds that remain to a full minute
	useTimeout(
		() => {
			setCurrentTime();
			setIsIntervalActive(true);
		},
		(60 - new Date().getSeconds()) * 1000
	);

	useInterval(setCurrentTime, isIntervalActive ? 60 * 1000 : null);

	useEffect(() => {
		setCurrentTime();
		//eslint-disable-next-line
	}, []);
};
